var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7f8e94",
    d: "M33 5H19V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z",
    opacity: 1,
    "data-original": "#7f8e94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545c60",
    d: "M31 1h-3a2 2 0 0 1 2 2v2h3V3a2 2 0 0 0-2-2z",
    opacity: 1,
    "data-original": "#545c60"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e9e9e",
    d: "M39 7v2a4.01 4.01 0 0 1-4 4H17a4.01 4.01 0 0 1-4-4V7a2.006 2.006 0 0 1 2-2h22a2.006 2.006 0 0 1 2 2z",
    opacity: 1,
    "data-original": "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M37 5h-3a2.006 2.006 0 0 1 2 2v2a4.01 4.01 0 0 1-4 4h3a4.01 4.01 0 0 0 4-4V7a2.006 2.006 0 0 0-2-2z",
    opacity: 1,
    "data-original": "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91562d",
    d: "M51 13v21a13 13 0 1 0-5.67 24.98c-.11.017-.22.023-.33.02H7a6 6 0 0 1-6-6V13a6 6 0 0 1 6-6h6v2a4 4 0 0 0 4 4h18a4 4 0 0 0 4-4V7h6a6 6 0 0 1 6 6z",
    opacity: 1,
    "data-original": "#91562d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6d4122",
    d: "M33 46a13 13 0 0 1 11.494-12.906A12.995 12.995 0 1 0 42.33 58.98c-.11.017-.22.023-.33.02h3c.11.003.22-.003.33-.02C38.42 58.626 32.998 52.92 33 46zM14 13h3a4 4 0 0 1-4-4V7h-3v2a4 4 0 0 0 4 4zM45 7h-3a6 6 0 0 1 6 6v20.171c1.03.156 2.037.434 3 .829V13a6 6 0 0 0-6-6z",
    opacity: 1,
    "data-original": "#6d4122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M47 13v20.05a8.269 8.269 0 0 0-1-.05 13 13 0 0 0-9.38 22H18L5 42V13a2.006 2.006 0 0 1 2-2h6.54A3.98 3.98 0 0 0 17 13h18a3.98 3.98 0 0 0 3.46-2H45a2.006 2.006 0 0 1 2 2z",
    opacity: 1,
    "data-original": "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M14 13h3a3.98 3.98 0 0 1-3.46-2h-3A3.98 3.98 0 0 0 14 13zM45 11h-3a2.006 2.006 0 0 1 2 2v20.05a8.269 8.269 0 0 0-1-.05 13 13 0 0 0-9.38 22h3A13 13 0 0 1 46 33c.334-.004.668.013 1 .05V13a2.006 2.006 0 0 0-2-2z",
    opacity: 1,
    "data-original": "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f44335",
    d: "M59 46c0 7.18-5.82 13-13 13-.21 0-.41 0-.62-.02h-.05c-7.02-.389-12.458-6.288-12.277-13.315S38.97 33.027 46 33c.334-.004.668.013 1 .05 1.376.098 2.727.419 4 .95a12.994 12.994 0 0 1 8 12z",
    opacity: 1,
    "data-original": "#f44335"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c81e1e",
    d: "M51 34a12.726 12.726 0 0 0-4-.95 8.269 8.269 0 0 0-1-.05c-.518.002-1.035.036-1.549.1 1.22.128 2.416.43 3.549.9a12.995 12.995 0 0 1-3.458 24.9c.262.03.522.066.788.08h.05c.21.02.41.02.62.02a13 13 0 0 0 5-25z",
    opacity: 1,
    "data-original": "#c81e1e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 11,
    x: 44,
    y: 37,
    fill: "#f5f5f5",
    rx: 2,
    transform: "rotate(180 46 42.5)",
    opacity: 1,
    "data-original": "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 53,
    r: 2,
    fill: "#f5f5f5",
    opacity: 1,
    "data-original": "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M18 55V44a2 2 0 0 0-2-2H5z",
    opacity: 1,
    "data-original": "#cfd8dc"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 9h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M52 33.37V13a7.008 7.008 0 0 0-7-7h-5.184A3 3 0 0 0 37 4h-3V3a3 3 0 0 0-3-3H21a3 3 0 0 0-3 3v1h-3a3 3 0 0 0-2.816 2H7a7.008 7.008 0 0 0-7 7v40a7.008 7.008 0 0 0 7 7h38c.14 0 .278-.01.416-.03.2.009.387.03.584.03a13.988 13.988 0 0 0 6-26.63zM50 13v19.59a13.773 13.773 0 0 0-2-.43V13a3 3 0 0 0-3-3h-5.1a5 5 0 0 0 .1-1V8h5a5.006 5.006 0 0 1 5 5zM17 52.586 7.414 43H16a1 1 0 0 1 1 1zM16 41H6V13a1 1 0 0 1 1-1h6.026A4.977 4.977 0 0 0 17 14h18a4.977 4.977 0 0 0 3.974-2H45a1 1 0 0 1 1 1v19a13.982 13.982 0 0 0-11.473 22H19V44a3 3 0 0 0-3-3zm4-38a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1H20zm-6 4a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v2a3 3 0 0 1-3 3H17a3 3 0 0 1-3-3zM7 58a5.006 5.006 0 0 1-5-5V13a5.006 5.006 0 0 1 5-5h5v1a5 5 0 0 0 .1 1H7a3 3 0 0 0-3 3v29a1 1 0 0 0 .293.707l13 13A1 1 0 0 0 18 56h18.221a14.065 14.065 0 0 0 2.605 2zm39 0c-6.627 0-12-5.373-12-12s5.373-12 12-12 12 5.373 12 12c-.007 6.624-5.376 11.993-12 12z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M46 36a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0v-7a3 3 0 0 0-3-3zm1 10a1 1 0 0 1-2 0v-7a1 1 0 0 1 2 0zM46 50a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.09c06069e85fdc9f8d921de0a12cb461.svg";
export { ForwardRef as ReactComponent };